export enum MainAxisSize {
  min = 1,
  max = 2,
}
